import { UseQueryResult } from '@tanstack/react-query';

import { Bookmark } from './types';
import { getBookmarks } from './getBookmarkList';
import { useSession } from '../../SessionProvider';

import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

export const useGetBookmarks = (): UseQueryResult<Bookmark[]> => {
  const { olSession } = useSession();

  return useQuery(['getBookmarks'], () => {
    return getBookmarks(olSession);
  });
};
